export interface IUser {
  id?: string;
  username: string;
  email: string;
  phoneNumber?: string;
  phone: {
    code: string;
    number: string;
  };
  firstName: string;
  lastName: string;
  gender?: string;
  // studentId: string;
  address?: string;
  status?: string;
  role: string;
  dob?: string;
  code?: string;
  isVerifiedEmail?: boolean;
  isVerifiedPhoneNumber?: boolean;
  avatar?: string;
  attachments?: string[];
  levelIds?: string[];
  roleIds?: string[];
  subjectIds?: string[];
  bankId?: string;
  bankNumber?: string;
  branchId?: string;
  roles?: {
    role?: string;
  };
}

export enum UserRole {
  Admin = 'admin',
  Student = 'student',
  Tutor = 'tutor',
}

export enum StatusCode {
  Deleted = 'deleted',
  Active = 'active',
  Disabled = 'disabled',
  Inactive = 'inactive',
}

export enum DiscountCode {
  Referral = 'referral_discount',
  Sibling = 'sibling_discount',
}
